import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import type { EditorThemeClasses, KlassConstructor, LexicalNode } from 'lexical';

/**
 * Centralized Lexical node configuration for rich text functionality.
 *
 * This ensures consistency between:
 * - HTML to Lexical conversion (server-side)
 * - Rich text viewer component (client-side)
 * - Future rich text editor components
 */
export const RICH_TEXT_NODES: KlassConstructor<typeof LexicalNode>[] = [
    // List support
    ListNode,
    ListItemNode,

    // Table support
    TableNode,
    TableRowNode,
    TableCellNode,

    // Link support
    LinkNode,
    AutoLinkNode,
];

/**
 * Default theme configuration for rich text display.
 * Applies our design system styles consistently.
 */
export const RICH_TEXT_THEME = {
    // Apply our design system styles
    paragraph: 'text-sm text-neutral-900 leading-relaxed mb-2 last:mb-0',
    text: {
        bold: 'font-semibold',
        italic: 'italic',
        underline: 'underline',
        strikethrough: 'line-through',
    },
    link: 'text-blue-600 hover:text-blue-700 hover:underline',
    list: {
        ul: 'list-disc list-inside space-y-1 mb-2',
        ol: 'list-decimal list-inside space-y-1 mb-2',
        listitem: 'text-sm text-neutral-900',
    },
    table: 'border-collapse border border-neutral-200 w-full mb-2 last:mb-0',
    tableCell: 'border border-neutral-200 p-3 text-sm',
    tableCellHeader: 'border border-neutral-200  p-3 text-sm font-semibold bg-neutral-50',
} satisfies EditorThemeClasses;
